import React from 'react';
export function Hero() {
  return <section className="w-full bg-transparent pt-2 pb-4 md:pt-2 md:pb-6" data-id="element-91">
      <div className="max-w-6xl mx-auto px-4 md:px-6" data-id="element-92">
        <div className="text-center space-y-2" data-id="element-93">
          <div className="flex justify-center mb-1" data-id="element-94">
            <span className="inline-flex items-center gap-1.5 border border-[#F87171]/50 rounded-full px-5 py-1.5 text-[#F87171] text-xs md:text-sm font-semibold bg-[#F87171]/10" data-id="element-95">
              🩺 Diseñado para consulta, aula y familias
            </span>
          </div>

          <h1 className="md:text-5xl lg:text-6xl text-white font-[900] text-[24px] font-[Poppins,_sans-serif]" data-id="element-96">
            Recursos psicopedagógicos{' '}
            <span className="text-[#C084FC]" data-id="element-97">listos</span> para usar en consulta
            y clase
          </h1>

          <div className="flex flex-col items-center pt-1 pb-1" data-id="element-98">
            <img src="https://cdn.magicpatterns.com/uploads/eVmUdhJvZ4DcSB9ohAbokR/caee14da-0156-4381-be5e-6344fefa0251_(1).png" alt="Megapack Psicopedagogía Kit Profesional" className="w-full max-w-3xl h-auto mt-[5px] mb-[5px] pl-[60px] pr-[60px]" data-id="element-99" />
            <p className="md:text-xl mt-3 tracking-wide font-[700] font-['Open_Sans',_sans-serif] text-[#B794D6] text-[16px]" data-id="element-100">
              Ahorrá horas de planificación con recursos imprimibles para
              consulta o clase.
            </p>
          </div>

          <div className="flex items-center justify-center gap-1.5 pt-2" data-id="element-101">
            <span className="text-yellow-400 text-sm" data-id="element-102">⭐⭐⭐⭐⭐</span>
            <span className="text-white text-sm font-semibold" data-id="element-103">4.9/5</span>
            <span className="text-gray-400 text-xs" data-id="element-104">
              Mas de 65 profesionales ya adquirieron este megapack hoy
            </span>
          </div>

          <div className="flex justify-center pt-2" data-id="element-105">
            <a href="#oferta-pro" className="inline-block bg-[#C084FC] hover:bg-[#9333EA] text-white font-bold px-8 py-4 rounded-lg transition-all duration-200 hover:scale-105 font-['Open_Sans',_sans-serif] text-[18px]" data-id="element-106">
              🧮→ ACCEDER AL MATERIAL
            </a>
          </div>

          <div className="flex flex-col items-center gap-2 text-xs md:text-sm text-white pt-2" data-id="element-107">
            <div className="flex flex-nowrap justify-center gap-2" data-id="element-108">
              <span className="flex items-center gap-1.5 border-2 border-[#9333EA] rounded-md px-3 py-1 whitespace-nowrap font-semibold" data-id="element-109">
                📄 Plantillas listas para usar
              </span>
              <span className="flex items-center gap-1.5 border-2 border-[#9333EA] rounded-md px-3 py-1 whitespace-nowrap font-semibold" data-id="element-110">
                ⚡ Ahorrá horas de planificación
              </span>
            </div>
            <span className="flex items-center gap-1.5 border-2 border-[#9333EA] rounded-md px-3 py-1 whitespace-nowrap font-semibold" data-id="element-111">
              📊 Informes y seguimiento más rápidos
            </span>
          </div>
        </div>
      </div>
    </section>;
}